<template>
  <div id="dropdown_bar" @mouseenter="onHover" @mouseleave="checkLeave" ref="bar">
    <slot></slot>
    <div 
        class="option_sheet" 
        v-show="visible" 
        :style="{'left': leftDistance + 'px'}"
        @mouseenter="isOnSheet = true"
        @mouseleave="isOnSheet = false"
      >
        <div class="option" v-for="option in options" :key="option.title" @click.stop="onJumpTo(option.path)">
            <span>{{option.title}}</span>
        </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, ref } from "vue";
import routeHash from '@/constant/router_hash'
import { useRouter } from 'vue-router'
import Mitt from "@/utils/mitt";
const props = defineProps(["options"]);

const visible = ref(false)
const isOnSheet = ref(false) 

const bar = ref(null)
const leftDistance = ref(0)
const router = useRouter()

const onJumpTo = (hash: string) => {
  if (hash.startsWith("/")) {
    router.push({ path: hash })
    return
  }
  setTimeout(() => Mitt.emit(hash), 0)
  switch(hash) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      router.push({ path: "/solution" })
      return;
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      router.push({ path: "/service" })
      return;
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      router.push({ path: "/product"})
      return;
    case routeHash.CONTACT_US:
      router.push({ path: "/company" })
      return;
    default:
      router.push({ path: hash })
      return
  }
}

const checkLeave = () => {
  setTimeout(() => {
    if (!isOnSheet.value) {
      visible.value = false
    }
  }, 100)
}

const onHover = () => {
    if(bar.value) {
        const barRect = (bar.value as HTMLElement).getBoundingClientRect();
        const left = barRect.left;  
        leftDistance.value = left
    }
    if(props.options) {
        visible.value = true
    }
}
</script>

<script lang="ts">
export default {
  name: 'DropdownBar'
}
</script>

<style lang="less" scoped>
#dropdown_bar {
    // position: relative;
    height: 4rem;
    display: flex;
    align-items: center;

  .option_sheet {
    background: var(--bg-color-white-light);
    animation: stretch 0.1s ease;
    animation-fill-mode: forwards;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: fixed;
    top: 4rem;
    right: 0;
    z-index: 10;
    border-radius: 4px;
    padding: 12px 0;
    max-width: 300px;

    @keyframes stretch {
      from {
        transform: scaleY(0);
        transform-origin: top;
      }
      to {
        transform: scaleY(1);
        transform-origin: top;
      }
    }

    .option {
        padding: 8px 18px;
        color: var(--font-color-gray-light);
        font-size: var(--primary-text);

        &:hover {
            background: var(--font-color-black-light);
            color: #f1f1f1;
        }
    }
  }
}
</style>
